<template>
  <div>
    <!-- Page Heading -->
    <br />

    <div class="text-left">
      <b-row>
        <b-col md="3" class="my-1">
          <b-row>
            <b-col md="4" class="pr-0">
              <h4 class="font-weight-bold text-primary">Summary</h4>
            </b-col>
            <b-col class="pt-1">
              <label
                v-if="summary"
                class="text-gray-500 font-weight-light"
                style="cursor: pointer;"
                @click="summary = !summary"
              >Hide</label>
              <label
                v-else
                class="text-primary font-weight-bold"
                style="cursor: pointer;"
                @click="summary = !summary"
              >Show</label>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </div>
    <br />
    <transition name="slide">
      <b-card v-show="summary" body-class="py-0 px-0">
        <b-row>
          <b-col class="border-right text-left pl-5 py-4">
            <b-row>
              <b-col>
                <h2 class="text-primary font-weight-bold mb-4">Rp 2.734.948.592</h2>
                <h5 class>Total Volume</h5>
                <h5 class="text-gray-600">
                  <i>Month to Date</i>
                </h5>
                <b-spinner v-if="loading" label="Loading..."></b-spinner>
                <!-- <h4 class="mb-0" v-else>{{ items ? items.total_ticket:items}}</h4> -->
              </b-col>
            </b-row>
          </b-col>
          <b-col md="2" class="border-right text-left pl-4 py-4">
            <h2 class="text-primary font-weight-bold mb-4">32214</h2>
            <h5 class>Total Transaction</h5>
            <h5 class="text-gray-600">
              <i>Month to Date</i>
            </h5>
          </b-col>
          <b-col md="3" class="border-right text-left pl-4 py-4">
            <h2 class="text-primary font-weight-bold mb-4">Rp 0</h2>
            <h5 class>Payable Amount</h5>
            <h5 class="text-gray-600">
              <i>Volume to date</i>
            </h5>
          </b-col>
          <b-col class="border-right text-left pl-4 py-4">
            <h2 class="text-primary font-weight-bold mb-4">Rp 128.690.531</h2>
            <h5 class>Last settlement amount</h5>
            <h5 class="text-gray-600">
              <i>17 June 2020</i>
            </h5>
          </b-col>
        </b-row>
      </b-card>
    </transition>
    <br />
    <!-- Content Row -->
    <b-row>
      <b-col md="4" class="my-1 text-left">
        <b-row>
          <b-col md="6" class="pr-0">
            <h4 class="font-weight-bold text-primary">Transaction Volume</h4>
          </b-col>
          <b-col class="pt-1">
            <label
              v-if="transaction"
              class="text-gray-500 font-weight-light"
              style="cursor: pointer;"
              @click="transaction = !transaction"
            >Hide</label>
            <label
              v-else
              class="text-primary font-weight-bold"
              style="cursor: pointer;"
              @click="transaction = !transaction"
            >Show</label>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <br />
    <transition name="slide">
      <div v-show="transaction">
        <b-card>
          <revenue
            :chartdata="chartData"
            :options="chartOptions"
            style="width:100%; height:100%; zoom:100% !important;"
          ></revenue>
        </b-card>
      </div>
    </transition>
    <br />
    <b-row>
      <b-col md="3" class="mt-4 text-left">
        <b-row>
          <b-col md="6" class="pr-0">
            <h4 class="font-weight-bold text-primary">Transactions</h4>
          </b-col>
          <b-col class="pt-1">
            <label
              v-if="transactions"
              class="text-gray-500 font-weight-light"
              style="cursor: pointer;"
              @click="transactions = !transactions"
            >Hide</label>
            <label
              v-else
              class="text-primary font-weight-bold"
              style="cursor: pointer;"
              @click="transactions = !transactions"
            >Show</label>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <transition name="slide">
      <div v-show="transactions" class="text-left">
        <b-row class="mt-4">
          <b-col md="4" class="my-1">
            <b-form-group class="mb-0">
              <b-input-group>
                <b-form-input v-model="filter" placeholder="Search"></b-form-input>
                <b-input-group-append>
                  <b-button variant="primary" :disabled="!filter" @click="filter = ''">Clear</b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col md="2" class="my-1" align="right">
            <b-form-group label-cols-sm="6" label="Show" class="mb-0">
              <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
            </b-form-group>
          </b-col>
          <b-col md="2"></b-col>
          <b-col md="2" class="my-1">
            <b-input-group style="justify-content: flex-end;">
              <b-input-group-text class="bg-white border-right-0" slot="prepend">
                <img src="@/assets/filter.svg" alt class="action_icon" />
              </b-input-group-text>
              <b-dropdown
                text="Filter Data"
                variant="light"
                toggle-class="bg-white border-secondary text-primary border-left-0 pl-0"
                slot="append"
              >
                <b-dropdown-item @click="allCategory()">All Category</b-dropdown-item>
                <b-dropdown-item
                  @click="FaqFilter(filter.id)"
                  v-for="filter in datafilter"
                  :key="filter"
                >{{filter.category_name.id}}</b-dropdown-item>
              </b-dropdown>
            </b-input-group>
          </b-col>
          <b-col md="2" class="my-1" align="right">
            <router-link :to="{name: 'createFaq'}">
              <download-csv class="d-none" :data="CSV" name="tickets.csv" ref="DownloadCSV"></download-csv>
              <b-button class="btn btn-primary" :disabled="loadingCSV" @click="downloadCSV()">
                <b-spinner label="Spinning" v-show="loadingCSV"></b-spinner>
                <i class="fas fa-file-export"></i> Export to CSV
              </b-button>
            </router-link>
          </b-col>
        </b-row>
        <b-row>
          <br />
        </b-row>
        <section v-if="errored">
          <p>We're sorry, we're not able to retrieve this information at the moment, please try back later</p>
        </section>
        <!-- Main table element -->
        <b-table
          v-else
          responsive
          show-empty
          hover
          :busy="loading"
          :items="items"
          :fields="fields"
          :current-page="currentPage"
          :per-page="perPage"
          :filter="filter"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :sort-direction="sortDirection"
          @filtered="onFiltered"
          head-variant="light"
          class="bg-white"
        >
          <div slot="table-busy" class="text-center text-primary my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong>Loading...</strong>
          </div>
          <template v-slot:cell(content.id)="row">
            <div v-html="row.value.substring(0,50)"></div>
          </template>
          <template v-slot:cell(image)="row">
            <b-img :src="row.value" width="75px" rounded alt="Image"></b-img>
          </template>
          <template v-slot:cell(created_at)="{ value, item }">
            <p class="mb-0">{{item.created_at_date_only}}</p>by
            <label class="font-weight-bold">{{item.created_by_username}}</label>
          </template>
          <template v-slot:cell(updated_at)="{ value, item }">
            <div v-if="item.updated_at_date_only == ''">-</div>
            <div v-else>
              <p class="mb-0">{{item.updated_at_date_only}}</p>by
              <label class="font-weight-bold">{{item.updated_by_username}}</label>
            </div>
          </template>
          <template v-slot:cell(action)="{ value, item }">
            <router-link
              :to="{name: 'detailTransaction', params: {id: item.id}}"
              class="text-primary"
              v-b-tooltip.hover
              title="View Detail"
            >
              <i class="fas fa-eye"></i>
            </router-link>
          </template>
        </b-table>
        <b-row class="mx-auto">
          <b-col md="4" class="mx-auto px-0">Total entries {{rows}}</b-col>
          <b-col md="4" class="mx-auto"></b-col>
          <b-col md="4" align="right" class="px-0">
            <b-pagination
              align="right"
              v-model="currentPage"
              :total-rows="rows"
              :per-page="perPage"
              class="my-0"
            ></b-pagination>
          </b-col>
        </b-row>
      </div>
    </transition>
  </div>
</template>

<script>
import ChartBar from "./chart/ChartBar.js";
import ChartLine from "./chart/ChartLine.js";

export default {
  components: {
    revenue: ChartLine,
    shipment: ChartLine,
    bukalapak: ChartLine
  },
  data() {
    return {
      items: [
        {
          id: 1,
          date_time: "TES",
          payment_method: "TES",
          status: "TES",
          amount: "TES",
          order_id: "TES",
          status: "TES"
        },
        {
          id: 2,
          date_time: "TES",
          payment_method: "TES",
          status: "TES",
          order_id: "TES",
          amount: "TES",
          status: "TES"
        },
        {
          id: 3,
          date_time: "TES",
          payment_method: "TES",
          status: "TES",
          order_id: "TES",
          amount: "TES",
          status: "TES"
        },
        {
          id: 4,
          date_time: "TES",
          payment_method: "TES",
          status: "TES",
          order_id: "TES",
          amount: "TES",
          status: "TES"
        }
      ],
      fields: [
        {
          key: "date_time",
          label: "Date & Time",
          sortable: true,
          class: "text-center"
        },
        {
          key: "payment_method",
          label: "Payment Method",
          sortable: true,
          class: "text-center"
        },
        {
          key: "order_id",
          label: "Order Id",
          sortable: true,
          class: "text-center"
        },
        {
          key: "amount",
          label: "Amount",
          sortable: true,
          class: "text-center"
        },
        {
          key: "status",
          label: "Status",
          sortable: true,
          class: "text-center"
        },
        { key: "action", label: "Action", class: "text-center w-10" }
      ],
      chartData: {
        labels: [
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
          "Saturday",
          "Sunday"
        ],
        datasets: [
          {
            barPercentage: 0.5,
            label: "Dana",
            data: [1, 2, 4, 4, 5, 6, 7],
            backgroundColor: "rgba(126,211,33,0.2)",
            borderColor: "rgba(126,211,33,1)",
            borderWidth: 2
          },
          {
            barPercentage: 0.5,
            label: "OVO",
            data: [2, 3, 4, 5, 8, 7, 8],
            backgroundColor: "rgba(245,166,35, 0.2)",
            borderColor: "rgba(245,166,35, 1)",
            borderWidth: 2
          },
          {
            barPercentage: 0.5,
            label: "Gopay",
            data: [3, 4, 5, 6, 7, 8, 9],
            backgroundColor: "rgba(255,67,79, 0.2)",
            borderColor: "rgba(255,67,79, 1)",
            borderWidth: 2
          },
          {
            barPercentage: 0.5,
            label: "BCA",
            data: [4, 5, 6, 7, 8, 9, 10],
            backgroundColor: "rgba(74,144,226, 0.2)",
            borderColor: "rgba(74,144,226, 1)",
            borderWidth: 2
          }
        ]
      },
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true
              }
            }
          ]
        }
      },
      summary: true,
      transactions: true,
      transaction: true,
      show: false,
      hover: false,
      loading: false,
      errored: false,
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      sortBy: null,
      sortDesc: false,
      sortDirection: "asc",
      filter: null
    };
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => ({ text: f.label, value: f.key }));
    }
  },
  mounted() {},
  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    changeView(payload) {
      this.active = payload;
    }
  }
};
</script>

<style scoped>
.small {
  max-width: 600px;
  margin: 150px auto;
}
.ganti {
  background: white;
  color: blue;
}
</style>
